export class InternalEquipmentCustomSelectValue {
    id: number;
    idField: number;
    value: string;
}